import { ClientType } from "redmond";

const clientTypes = ["app", "web"] satisfies ClientType[];

// this function ensures ClientType in config will always fall back to 'web' if leamouth config is outdated
export const getConfigClientType = () => {
  const configClientType = (window.__mclean_env__?.CLIENT_TYPE ??
    window.__portal_env__?.CLIENT_TYPE ??
    process?.env?.CLIENT_TYPE ?? "web") as ClientType;
  return clientTypes.includes(configClientType) ? configClientType : "web";
};
